import React from 'react';
import canopyLogo from "../../assets/icons/canopy.png";
// Import the new images
import setupImage from "../../assets/images/setup.JPG";
import hubImage from "../../assets/images/hub.JPG";
import sensorImage from "../../assets/images/sensor.png";
import actionsImage from "../../assets/images/actions.png";
import instagramQR from "../../assets/images/canopy_insta_qr_code.png";
import linkedinQR from "../../assets/images/canopy_linkedin_qr_code.png";
import irrigationDemo from "../../assets/images/irrigation_demo.MOV";
import "../../styles/about.css";
import "../../styles/unifiedCards.css";
import CanopyArchitecturePyramid from "./CanopyArchitecturePyramid";

export default function About() {
    return (
        <div className="about-container">
            {/* Hero Section */}
            <div className="about-hero">
                <div className="about-hero-content">
                    <img src={canopyLogo} alt="Canopy Systems" className="about-logo" />
                    <h1 className="about-title">About Canopy Systems</h1>
                    <p className="about-subtitle">
                        Smart IoT monitoring and automation for home plant care
                    </p>
                </div>
            </div>

            {/* Main Content */}
            <div className="about-content">
                {/* Company Overview */}
                <section className="about-section">
                    <h2 className="about-section-title">Our Mission</h2>
                    <div className="about-mission-grid">
                        <div className="mission-content">
                            <p className="about-text">
                                Canopy Systems is a personal project exploring smart home plant care through IoT technology. 
                                The platform helps growers monitor and automate their indoor gardens with real-time insights 
                                into plant environment conditions.
                            </p>
                            <p className="about-text">
                                The system works through three main components: sensor cards that monitor your plants&apos; environment, 
                                action cards that control automation devices, and care plans that create intelligent schedules 
                                for watering, lighting, and climate control. This intuitive structure makes it easy to set up 
                                automated plant care routines that adapt to your specific plants&apos; needs.
                            </p>
                        </div>
                        <div className="mission-image">
                            <img src={setupImage} alt="Canopy Systems Setup" className="setup-image" />
                        </div>
                    </div>
                </section>

                <CanopyArchitecturePyramid />

                {/* Platform Components */}
                <section className="about-section">
                    <h2 className="about-section-title">How It Works</h2>
                    <div className="about-hardware-grid">
                        <div className="hardware-item">
                            <div className="hardware-image">
                                <img src={sensorImage} alt="Sensor Cards" className="hardware-img" />
                            </div>
                            <h3>Sensor Cards</h3>
                            <p>Monitor your plants&apos; environment with real-time data on temperature, humidity, moisture, and light levels</p>
                        </div>
                        <div className="hardware-item">
                            <div className="hardware-image">
                                <img src={actionsImage} alt="Action Cards" className="hardware-img" />
                            </div>
                            <h3>Action Cards</h3>
                            <p>Control automation devices like irrigation systems, grow lights, and fans based on sensor readings</p>
                            
                            {/* Irrigation Demo Video */}
                            <div className="demo-video-container">
                                <h4>See It In Action</h4>
                                <div className="video-wrapper">
                                    <video 
                                        className="demo-video"
                                        controls
                                        preload="metadata"
                                        poster={actionsImage}
                                    >
                                        <source src={irrigationDemo} type="video/quicktime" />
                                        <source src={irrigationDemo} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                                <p className="video-description">
                                    Watch our irrigation system in action - automatically watering plants based on soil moisture levels
                                </p>
                            </div>
                        </div>
                        <div className="hardware-item">
                            <div className="hardware-image">
                                <img src={hubImage} alt="Care Plans" className="hardware-img" />
                            </div>
                            <h3>Care Plans</h3>
                            <p>Create intelligent automation schedules that adapt to your plants&apos; specific needs and growth cycles</p>
                        </div>
                    </div>
                </section>

                {/* Social Media & Contact */}
                <section className="about-section">
                    <h2 className="about-section-title">Connect With Us</h2>
                    <div className="about-social-column">
                        <div className="social-card">
                            <h3>Follow Our Journey</h3>
                            <p>Stay updated with our latest developments, case studies, and industry insights</p>
                            <div className="qr-codes">
                                <div className="qr-item">
                                    <img src={instagramQR} alt="Instagram QR Code" className="qr-code" />
                                    <p>Instagram</p>
                                </div>
                                <div className="qr-item">
                                    <img src={linkedinQR} alt="LinkedIn QR Code" className="qr-code" />
                                    <p>LinkedIn</p>
                                </div>
                            </div>
                        </div>
                        <div className="contact-card">
                            <h3>Get In Touch</h3>
                            <div className="contact-info">
                                <div className="contact-item">
                                    <i className="ri-mail-line"></i>
                                    <span>info@canopysystems.com</span>
                                </div>
                                <div className="contact-item">
                                    <i className="ri-phone-line"></i>
                                    <span>+1 (555) 123-4567</span>
                                </div>
                                <div className="contact-item">
                                    <i className="ri-map-pin-line"></i>
                                    <span>Innovation District, Tech City</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
} 